import PropTypes from 'prop-types';
// @mui
import { Divider, Box, Card, Link, Typography, Stack, Button } from '@mui/material';
// styled removed (not used)

// ----------------------------------------------------------------------

ShopProductCard.propTypes = {
  product: PropTypes.object,
};

export default function ShopProductCard({ product }) {
  const { name, info } = product;
  const link = product.teacher_material;

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 3,
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: 6,
        },
      }}
    >
      <Stack spacing={2} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link color="text.primary" underline="hover">
            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 22 }} noWrap>
              {name}
            </Typography>
          </Link>

          {/* price shown on its own row below if available */}
          <Box />
        </Box>

        <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>Опис: {info}</Typography>

        <Divider />

        {link ? (
          <Box>
            <Button component="a" href={link} target="_blank" rel="noreferrer" size="small">
              Презентація
            </Button>
          </Box>
        ) : null}
      </Stack>
    </Card>
  );
}
